import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SubmissionDetailsActionsService } from '../../../actions/submission-details-actions.service';
import { SubmissionDetailsAppBarStatusType } from './submission-details-app-bar-title.model';
import { SubmissionsFacade } from './../../../../../domain/+state/submissions.facade';
import { getContactString } from '../../../submission-details.data';

@UntilDestroy()
@Component({
    selector: 'ifbp-submission-details-app-bar-title',
    templateUrl: './submission-details-app-bar-title.component.html',
    styleUrls: ['./submission-details-app-bar-title.component.scss'],
    standalone: false
})
export class SubmissionDetailsAppBarTitleComponent implements OnInit {
  title: string;
  statusType: SubmissionDetailsAppBarStatusType = SubmissionDetailsAppBarStatusType.Empty;
  contactString: string;
  readonly StatusType = SubmissionDetailsAppBarStatusType;

  constructor(
    private readonly actions: SubmissionDetailsActionsService,
    private readonly submissionsFacade: SubmissionsFacade,
  ) { }

  ngOnInit(): void {
    this.submissionsFacade.getAdvisorData$().pipe(untilDestroyed(this)).subscribe((data) => this.contactString = getContactString(data, false));
    this.actions.updateSubmissionDetailsAppBarTitle$.pipe(untilDestroyed(this)).subscribe((data) => {
      this.title = data.title || this.title;
      this.statusType = data.statusType || this.statusType;
    })
  }
}
